import React, { useState } from "react";

import Header from "../../components/ui/Header";
import { Upload, FileText, Send, BarChart3, Settings, Globe2, CreditCard } from "lucide-react";
import UploadFlow from './components/UploadFlow';
import TemplatesGallery from './components/TemplatesGallery';
import DistributionPlanner from './components/DistributionPlanner';
import AnalyticsView from './components/AnalyticsView';
import PricingTiers from './components/PricingTiers';
import SettingsView from './components/SettingsView';
import DashboardView from './components/DashboardView';



// Simple utility components
const TabButton = ({ icon: IconComponent, label, active, onClick }) => (
  <button
    onClick={onClick}
    className={`flex items-center gap-2 px-4 py-2 rounded-2xl transition shadow-sm border ${
      active ? "bg-black text-white border-black" : "bg-white hover:bg-gray-50 border-gray-200"
    }`}
  >
    <IconComponent size={18} />
    <span className="font-medium">{label}</span>
  </button>
);

export default function PRDistribution() {
  const [tab, setTab] = useState("Dashboard");

  const tabs = [
    { label: "Dashboard", icon: Globe2 },
    { label: "Upload", icon: Upload },
    { label: "Templates", icon: FileText },
    { label: "Distribution", icon: Send },
    { label: "Analytics", icon: BarChart3 },
    { label: "Pricing", icon: CreditCard },
    { label: "Settings", icon: Settings },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100">
      <Header />
      {/* Top Bar */}
      <header className="sticky top-16 z-20 bg-white/80 backdrop-blur-md border-b border-gray-100">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="h-10 w-10 rounded-2xl bg-black text-white grid place-items-center font-bold">PR</div>
            <div>
              <h1 className="text-xl font-bold leading-tight">PenGame PR Distribution</h1>
              <p className="text-xs text-gray-500 -mt-0.5">AI-assisted press release distribution</p>
            </div>
          </div>

          <div className="flex items-center gap-2">
            {tabs?.map((t) => (
              <TabButton
                key={t?.label}
                icon={t?.icon}
                label={t?.label}
                active={tab === t?.label}
                onClick={() => setTab(t?.label)}
              />
            ))}
          </div>
        </div>
      </header>
      {/* Content */}
      <main className="max-w-7xl mx-auto px-6 py-8">
        {tab === "Dashboard" && <DashboardView />}
        {tab === "Upload" && <UploadFlow />}
        {tab === "Templates" && <TemplatesGallery />}
        {tab === "Distribution" && <DistributionPlanner />}
        {tab === "Analytics" && <AnalyticsView />}
        {tab === "Pricing" && <PricingTiers />}
        {tab === "Settings" && <SettingsView />}
      </main>
      <footer className="max-w-7xl mx-auto px-6 py-10 text-center text-sm text-gray-500">
        © {new Date()?.getFullYear()} PenGame Publishing – PR Distribution Platform
      </footer>
    </div>
  );
}